// App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Layout from "./Layout";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import MCUManager from "./pages/MCUManager";
import Settings from "./pages/Settings";
import { ToastContainer,toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ManageFarms from "./pages/ManageFarm";
import ControllerManager from "./pages/ControllerManager";
import SensorManager from "./pages/SensorManager";
import ProtectedRoute from "./components/ProtectedRoute";
  import { onForegroundMessage } from "./utils/firebase-messaging";
import ManageSettingProfiles from "./pages/ManageSettingsProfiles";

function App() {




useEffect(() => {
  const unsubscribe = onForegroundMessage((payload) => {
    console.log("Foreground message received: ", payload);

    // 1. Show toast
    toast.info(payload?.notification?.title || "New Notification");

    // 2. Save to database (example API call)
    // fetch("/api/save-notification", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify(payload),
    // });
  });

  // Clean up
  return () => {
    if (typeof unsubscribe === "function") unsubscribe();
  };
}, []);

  return (
    <>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="farms" element={<ManageFarms />} />
              <Route path="mcu" element={<MCUManager />} />
              <Route path="controllers" element={<ControllerManager />} />
              <Route path="sensors" element={<SensorManager />} />
              <Route path="settings-profile" element={<ManageSettingProfiles />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Route>
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
